// extracted by mini-css-extract-plugin
export default {"project-tabs":"BackOffice_project-tabs__iI3Fd"};